// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div[role=tabpanel] {
    background-color: #fff
}
`, "",{"version":3,"sources":["webpack://./src/salesCore/confirmationForm/assets/style.css"],"names":[],"mappings":"AAAA;IACI;AACJ","sourcesContent":["div[role=tabpanel] {\r\n    background-color: #fff\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
